/**
 *
 * Office Map UI
 *
 * Renders the UI functions for displaying the offices in the offices map
 */

const $ = require( 'jquery' );

class OfficesMap{

  constructor(el){

    this.$el = $(el);
    this.$svgMap = this.$el.find('.itbl-world-map-svg');
    this.$officeGroups = this.$el.find( '.itbl-office-group' );
    this.$officeInfos   = this.$el.find( '.itbl-c-office__info' );
    this.$mobileImgCtas = this.$el.find('.itbl-c-office__cites-cta');
    this.$defaultCity = this.$el.attr('data-default');

    this.animations = {};
    this.activeOfficeId = null;
    this.activeOfficeEl = null;
    this.activeTween = null;

    this.mapTimelines();
    this.events();
  }

  events(){
    this.event__intersectCity();
    this.$officeGroups.on( 'click', this.event__handlePinClick.bind( this ) );
    this.$mobileImgCtas.on('click', this.event__handleImgClick.bind(this) );
    
  }

  event__handleImgClick(event){

    event.preventDefault();

    //get the city from the data attribute
    let $el = $(event.currentTarget),
      city = $el.attr('data-office');

    try {

      this.activateOfficeUi( city );

    }catch (e) {

      console.log(e);
    }

  }

  //event which map is clicked, get currenttarget, get ID, which matches the object key, if key exists, trigger animation
  //if there's no ID, then reverse activeOffice if has value
  event__handlePinClick(event){

    event.preventDefault();

    //for the pins, the city is saved in the ID, since svgs can't have the data attr
    let $el = $(event.currentTarget),
      id  = $el.attr('id');

    try{
      this.activateOfficeUi( id );

    }catch (e) {

      console.log(e);
    }

  }

  activateOfficeUi( city ){

    //reverse all active tweens
    Object.keys( this.animations ).forEach( (key)=>{

      this.animations[key].timeScale(1.5).reverse();

    } );

    //remove the active class from everything
    this.$officeGroups.removeClass('itbl-office-is-active');

    //remove the office info active classes
    this.$officeInfos.removeClass( 'info-is-active' );

    //remove the office ctas active classes
    this.$mobileImgCtas.removeClass( 'cta-is-active' );

    //if this isn't same node, active the animation and trigger the office info
    if( this.animations[city] && Object.prototype.hasOwnProperty.call(this.animations, city ) && city !== this.activeOfficeId ){

      this.activeOfficeId = city;

      this.activeTween = this.animations[city].timeScale(1).play();

      this.$officeGroups.filter( `[id="${city}"]` ).addClass( 'itbl-office-is-active' );

      this.$officeInfos.filter( `[data-office*="${city}"]` ).addClass( 'info-is-active' );

      this.$mobileImgCtas.filter( `[data-office*="${city}"]` ).addClass('cta-is-active')

    }else if( city === this.activeOfficeId ){

      //return the active Id to null state if the user has clicked on the active city twice
      this.activeOfficeId = null;
    }
  }


  //iterate over the office groups and populate object with key and init timeline
  mapTimelines(){

    this.$officeGroups.each( (i, el )=>{

      let $el = $(el),
        id = $el.attr('id'),
        cityImg = $el.find('.itbl-office-img'),
        cityLabel = $el.find( '.itbl-office-label' ),
        tween = new window.TimelineMax( {paused: true} );

      tween
        .add('scalePin')
        .to($el, .2,
          {
            scale: 2.5,
            transformOrigin: "50% bottom",
            ease: window.Back.easeOut.config(1.7)
          }, 'scalePin')
        .fromTo( cityImg , .2, {scale: .4, transformOrigin: "center"}, {
          opacity: 1,
          scale: .97
        }, 'scalePin');

      this.animations[ id ] = tween;

    } );

  }

  event__intersectCity(){

    //if there is no intersection observer in browser, then play animation
    if (!('IntersectionObserver' in window)){
      return;
    }

    //config
    const config = {
      rootMargin: '0px 0px -50% 0px',
    };

    //setup intersection observer instance
    let observer = new IntersectionObserver( (entries)=> {
      entries.forEach(entry => {

        //if we are intersecting then play animation
        if( entry.isIntersecting ){

          this.activateOfficeUi( 'city__' + this.$defaultCity );

          observer.unobserve( entry.target );

        }

      });
    }, config);

    this.$el.get().forEach(el => {
      try{
        observer.observe(el);

      }catch (e) {
        console.log(e);
      }
    });

  }

}

$(document).ready(function(){
  $('.itbl-c-offices').each(function(){
    new OfficesMap(this);
  });

});
